import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaComponent1.vue?vue&type=template&id=08819ca8&scoped=true"
import script from "./AccettazioneSsnImpegnativaComponent1.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaComponent1.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnImpegnativaComponent1.vue?vue&type=style&index=0&id=08819ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08819ca8",
  null
  
)

export default component.exports